import { AxiosResponse } from "axios";
import { ApiResponse } from "../models/ApiResponse";

export function handleResponse(apiResponse: AxiosResponse<ApiResponse>) {
  return { ...apiResponse.data, code: 200 }
}